export default __webpack_public_path__ + "static/media/codeEditor.ce4dac11.png";